module.exports = __webpack_public_path__ + "media/flags/hn-8e1134e5.svg";